module.exports = __webpack_public_path__ + "img/exam_vr_itemback.95e03474.png";